





















import $ from "jquery";
import Vue from "vue";
import Component from "vue-class-component";
import axios from "axios";
import "./../../static/js/jquery-vendor";
import "./../../static/js/flashcanvas.min.js";
import "./../../static/js/jSignature.min.js";
import saveAs from "file-saver";
// import "./../../static/js/jquery.wordexport";
// import jsPDF from 'jspdf';
// import '../../static/js/canvas2image';
// import '../../static/js/html2canvas';

import { SignName, SignAble, SignZhipei } from "@/api/accident/edit";
import { log } from "console";

@Component({
  name: "sign",
})
export default class Sign extends Vue {
  public showCase: boolean = true;
  public contentText: string = "";
  public accidentId: string = ""; //定责测试202109140002  直赔测试 202110190001
  public telPhone: string = ""; //定责测试15136347537  直赔测试  13657083265
  public phone: string = ''; // 与英才对接,新增加参数
  public booktype: any = "";
  public imgUrl: string = "";
  //https://yancheng-traffic-1256445085.cos.ap-shanghai.myqcloud.com/traffic/3701ac246adfa9cb9cae341e9d6ee0f80.jpg

  public created() {
    window.onresize = function () {
      let { width, height } = window.screen;
    };
  }

  public mounted() {
    this.queryAgree();
  }

  public showSign() {
    this.showCase = false;

    $("#box").empty();
    $(function () {
      $("#box").jSignature({
        color: "#000",
        height: "100%",
        width: "100%",
        lineWidth: "5",
        backgroundColor: "#fff",
      });
    });
  }

  public clear() {
    $("#box").jSignature("reset");
  }
  public viewResult() {
    this.showCase = true;
    this.queryAgree();
  }
  public queryAgree() {
    console.log(
      this.$route.query.telPhone,
      this.$route.query.accidentId,
      this.$route.query.type,
      this.$route.query.phone
    );
    if (this.$route.query) {
      this.telPhone = this.$route.query.telPhone.toString();
      this.accidentId = this.$route.query.accidentId.toString();
      this.booktype = this.$route.query.type;
    }

    if (this.booktype == "1") {
      SignName(this.accidentId, this.telPhone).then((res:any) => {
        console.log(res.data?.signedStatementUrl)
        console.log(res.data?.statementUrl)
        if (res.data?.statementUrl) {
          let iURL = res.data?.statementUrl;
          this.imgUrl = iURL;
        } else {
          let URL = res.data?.signedStatementUrl;
          this.imgUrl = URL;
        }
      });
    } else {
      SignZhipei(this.accidentId, this.telPhone, this.booktype).then(
        (res: any) => {
          if (res.data?.signedApplication == null) {
            this.imgUrl = res.data?.application;
          } else {
            this.imgUrl = res.data?.signedApplication;
          }
        }
      );
    }
  }

  // 将url所代表的图标压缩到1
  public decreaseImage(data, fn) {
    const img = new Image();
    let res;
    img.src = data;
    img.width = 500;
    img.height = 400;
    img.onload = function () {
      const that = this;
      let canvas = document.createElement("canvas");
      let ctx: any = canvas.getContext("2d");
      $(canvas).attr({ width: 375, height: 300 });
      ctx.drawImage(that, 0, 0, 375, 300);
      res = canvas.toDataURL("image/png");
      $(canvas).remove();
      fn(res);
    };
  }
  // 将base64转换为blob
  public dataURLtoBlob(dataurl) {
    let arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }
  // 将blob转换为file
  public blobToFile(theBlob, fileName) {
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return new File([theBlob], "sign.png", {
      type: "image/png",
    });
  }

  public submit() {
    // console.log($("#box").jSignature("getData", "native").length,$("#box").jSignature("getData", "default"))
    if ($("#box").jSignature("getData", "native").length !== 0) {
      let data = $("#box").jSignature("getData", "default");
      // 将签名的突变缩小
      data = this.decreaseImage(data, (data) => {
        console.log("缩小后的签名图片", data);
        $("#record").append(`<img src=${data} />`);
        let formData = new FormData();
        const file = this.blobToFile(this.dataURLtoBlob(data), "sign.png");
        console.log(file);
        formData.append("file", file);
        formData.append("accidentId", this.accidentId);
        formData.append("telPhone", this.telPhone);
        formData.append("type", this.booktype);
        console.log(
          formData,
          "formDataformData"
          // file,
          // this.dataURLtoBlob(data)
        );
        formData.forEach((el) => {
          console.log(el);
        });
        // SignAble(formData).then((res)=>{
        //   console.log(res)
        // })
        if (this.booktype == "1") {
          axios({
            method: "PUT",
            headers: {
              "content-type": "multipart/form-data",
            },
            url: "/accidentparty/saveSignByAccidentIdAndDriverId",
            data: formData,
          }).then((resp) => {
            console.log("定责图片地址:", resp.data.data);
            if (resp.data.code === 200) {
              // window.open(resp.data.data, '_self');
              this.viewResult();
            } else {
              this.$message({ message: resp.data.msg, type: "warning" });
            }
          });
        } else {
          axios({
            method: "PUT",
            headers: {
              "content-type": "multipart/form-data",
            },
            url: "/accidentWounded/saveSignByAccidentIdAndDriverId",
            data: formData,
          }).then((resp) => {
            console.log("直赔图片地址:", resp.data.data);
            if (resp.data.code === 0) {
              // window.open(resp.data.data, '_self');
              this.viewResult();
            } else {
              this.$message({ message: resp.data.msg, type: "warning" });
            }
          });
        }
      });
    } else {
      this.$message({ message: "请先签名", type: "warning" });
    }
  }
}
